module.exports = __webpack_public_path__ + "octopus-service-440.05377833b8de11b5cc150da3f02c0ef6.hashedasset.svg";